import { renderModel } from '../../util/renderModel';
import { biLogger } from '../biLogger';
import { selectBiData } from '../selectors';
import { BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logChatbotClickButtonOnHeader: BiEventLogger<{
  clickedText: string;
  clickedTextId: string;
  clickedUrl?: string;
}> = async (state, data) => {
  const biData = selectBiData(state);
  const { sessionId } = await getRuntimeDataForBi(state);
  await biLogger.chatbotClickButtonOnHeader(state, {
    conversation_id: biData.conversationId,
    self_service_session_id: sessionId,
    clicked_text: data.clickedText,
    clicked_text_id: data.clickedTextId,
    header_lang: renderModel.getLocale(),
    clicked_url: data.clickedUrl,
    source_name: 'Full Page',
  });
};
